<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <v-card>
      <v-card-title class="redColor text-white">
        <span v-if="edit === true" class="headline">
          {{ $t("car_locations.edit_car_location") }}
        </span>
        <span v-if="edit === false" class="headline">
          {{ $t("car_locations.create_car_location") }}
        </span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container grid-list-md>
            <v-row wrap>
              <v-col cols="12" xs="12" md="12" lg="12">
                <v-text-field
                  v-model="carLocation.name"
                  :rules="rules.required"
                  :label="$t('car_locations.form.name')"
                  variant="solo"
                />
              </v-col>
              <v-col cols="12" xs="12" md="12" lg="12">
                <v-text-field
                  v-model="carLocation.description"
                  :label="$t('car_locations.form.description')"
                  variant="solo"
                />
              </v-col>
              <v-col
                v-if="
                  $store.getters.role === 'LekoAdmin' ||
                  $store.getters.role === 'LekoEmployee' ||
                  $store.getters.role === 'SuperAdmin'
                "
                xs="12"
                md="12"
                lg="12"
              >
                <v-select
                  v-model="carLocation.institution_id"
                  :rules="rules.required"
                  :items="institutions"
                  :loading="loadingInstitutions"
                  :label="$t('home.select_institution')"
                  color="red-darken-1"
                  item-title="title"
                  item-value="_id"
                  variant="solo"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <!-- Mobile: stacked full-width buttons -->
        <div class="d-flex d-sm-none flex-column ga-2 w-100">
          <v-btn color="red-darken-1" variant="outlined" block @click="close">
            {{ $t("car_locations.form.close") }}
          </v-btn>
          <v-btn
            color="green-darken-3"
            variant="outlined"
            :loading="loading"
            block
            @click="save"
          >
            {{ $t("car_locations.form.save") }}
          </v-btn>
        </div>

        <!-- Desktop: unchanged inline buttons -->
        <div class="d-none d-sm-flex">
          <v-btn color="red-darken-1" variant="outlined" @click="close">
            {{ $t("car_locations.form.close") }}
          </v-btn>
          <v-btn
            color="green-darken-3"
            variant="outlined"
            :loading="loading"
            class="ml-2"
            @click="save"
          >
            {{ $t("car_locations.form.save") }}
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import getRequest from "../../api/getRequest";
import postRequest from "../../api/postRequest";
import putRequest from "../../api/putRequest";

export default {
  data: () => ({
    dialog: false,
    valid: false,
    loading: false,
    loadingInstitutions: false,
    rules: {
      required: [(v) => !!v || "Please fill this field"],
    },
    carLocation: {},
    institutions: [],
    edit: null,
  }),
  methods: {
    open(edit, carLocation) {
      // assign data
      this.edit = edit;
      if (carLocation) this.carLocation = carLocation;
      if (
        this.$store.getters.role === "LekoAdmin" ||
        this.$store.getters.role === "LekoEmployee" ||
        this.$store.getters.role === "SuperAdmin"
      )
        this.getInstitutions();
      // open
      this.dialog = true;
    },
    close() {
      this.$emit("close");
      this.dialog = false;
      this.loading = false;
      this.carLocation = {};
      this.institutions = [];
    },
    save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        // assign institution
        if (
          this.$store.getters.role === "User" ||
          this.$store.getters.role === "EbayOperator" ||
          this.$store.getters.role === "InstitutionManager" ||
          this.$store.getters.role === "InstitutionAdmin"
        ) {
          this.carLocation.institution_id = this.$store.getters.institutionId;
        }
        // save
        if (this.edit) {
          putRequest(
            "/car-location",
            `id=${this.carLocation._id}`,
            this.carLocation,
          )
            .then((response) => {
              this.$emit("save", response);
            })
            .catch(() => {})
            .finally(() => {
              this.loading = false;
              this.close();
            });
        } else {
          postRequest
            .object("/car-location", this.carLocation)
            .then((response) => {
              this.$emit("save", response);
            })
            .catch(() => {})
            .finally(() => {
              this.loading = false;
              this.close();
            });
        }
      }
    },
    getInstitutions() {
      this.loadingInstitutions = true;
      getRequest("/institution")
        .then((response) => {
          this.institutions = response.institutions;
        })
        .catch(() => {})
        .finally(() => {
          this.loadingInstitutions = false;
        });
    },
  },
};
</script>
